// extracted by mini-css-extract-plugin
export default {"container":"LoginPageHeader_container__S10wF","bold":"LoginPageHeader_bold__jdeSD"};